export default "__VITE_ASSET__D5YlFNV3__"